import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import {
  OAuthSignInButton,
  OAuthSignOutButton
} from 'components';
import styles from './styles';
import googleLogo from 'images/search.png';
import Facebook from './Facebook';
import EmailSignInForm from 'components/EmailSignInForm';
import Snackbar from '@material-ui/core/Snackbar';
import { toggleNotification } from 'actions/commonActions';
import { browserHistory } from "react-router";

class Login extends React.Component {
  icon = () => {
    return <img src={googleLogo} alt='Google' style={{ width: '15px', marginRight: '3px' }}/>
  }

  renderNotification = () => {
    if (this.props.notificationMsg) {
      return (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={!!this.props.notificationMsg}
          onClose={()=>{this.props.dispatch(toggleNotification())}}
          message={<span id='message-id'>{this.props.notificationMsg}</span>}
        />
      );
    }
  }

  render = () => {
    const { signedIn, classes } = this.props;

    return (
      signedIn ? (
        <OAuthSignOutButton>
          Sign Out
        </OAuthSignOutButton>
        ) : (
        <Card style={{ margin: '200px auto', width: '300px', textAlign: 'center' }}>
          <CardContent>
            { this.renderNotification() }
            <Typography variant="title" className={classes.title} color="inherit">
              Login
            </Typography>
            <EmailSignInForm
              next={() => browserHistory.push("/account")}
              endpoint={this.props.pageEndpoint} />
            <br />
            <OAuthSignInButton
              provider='google'
              icon={this.icon()}
              signInParams={{ prompt: 'consent' }}
            >
              Google
            </OAuthSignInButton>
            <Facebook dispatch={this.props.dispatch} />
          </CardContent>
        </Card>
        )
    );
  }
}

const mapStateToProps = (state) => {
  const signedIn = !!state.auth.getIn(['user', 'isSignedIn']);
  return { signedIn, notificationMsg: state.app.notificationMsg };
};

const component = connect(mapStateToProps)(Login);
export default withStyles(styles)(component);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js